export const STRIPE_FEE_PERCENT = 3.4;
export const STRIPE_FEE_MULTIPLIER = 1.034;
export const STRIPE_TAX_CODE_MEDICAL_SERVICES = "txcd_20060027";

export const STRIPE_IDENTIFIER_SYSTEM_ACCOUNTS = "stripe.accounts";
export const STRIPE_IDENTIFIER_SYSTEM_CUSTOMERS = "stripe.customers";
export const STRIPE_IDENTIFIER_SYSTEM_PRODUCTS = "stripe.products";
export const STRIPE_IDENTIFIER_SYSTEM_PRICES = "stripe.prices";
export const STRIPE_IDENTIFIER_SYSTEM_PAYMENT_LINKS = "stripe.payment_links";
export const STRIPE_IDENTIFIER_SYSTEM_PAYMENT_LINK_URLS = "stripe.payment_links.url";
export const STRIPE_PRODUCT_LAB_PANELS = "stripe.products.lab_panels";

/**
 * Marks the setup-mode Checkout Session that collects a practice's lab-billing card, so the webhook
 * can tell it apart from a lab-fee payment.
 *
 * Lives here rather than beside the payment-method helpers because the webhook route needs only this
 * string: importing it from `practice-payment-method` pulled in the Practice model and, through it,
 * every background job that model's graph touches.
 */
export const LAB_BILLING_CARD_SETUP_IDENTIFIER = "lab-billing-card-setup";
